import { render, staticRenderFns } from "./BillsOverview.vue?vue&type=template&id=964115e4&scoped=true"
import script from "./BillsOverview.vue?vue&type=script&lang=js"
export * from "./BillsOverview.vue?vue&type=script&lang=js"
import style0 from "./BillsOverview.vue?vue&type=style&index=0&id=964115e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964115e4",
  null
  
)

export default component.exports